export default __webpack_public_path__ + "static/media/newsPaper.a51d9ae8.svg";